import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { getOrgTermsContent } from '../../content/utils.js';

function StatusFilter({
  statuses,
  selectedStatusIds = [],
  subject,
  handleSelect,
}) {
  const selectedCount = selectedStatusIds.length;
  const renderMenuItem = useCallback(
    (status) => (
      <React.Fragment key={status.id}>
        <MenuItem
          active={selectedStatusIds.includes(status.id)}
          eventKey={status.id}
          onSelect={handleSelect}
        >
          <span>{status.name}</span>
        </MenuItem>
      </React.Fragment>
    ),
    [selectedStatusIds]
  );

  return (
    <div className="flex">
      <div className="text-muted filter-label text-capitalize m-r-8">
        {getOrgTermsContent(subject)} Status
      </div>
      <ButtonToolbar style={{ minWidth: '204px' }}>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id={`${subject}-statuses-filter`}
          className="btn-block"
          pullRight
        >
          <MenuItem
            onSelect={handleSelect}
            eventKey={null}
            active={!selectedStatusIds.length}
          >
            All
          </MenuItem>
          <MenuItem divider />
          {statuses.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default StatusFilter;
